import * as Sentry from "@sentry/react";
import {
  LOAD_PSL,
  LOAD_PSL_ERROR,
  TOGGLE_REMOVE_FROM_PSL_MODAL,
  SET_REMOVE_FROM_PSL_LOADING,
  SUBMIT_REMOVE_FROM_PSL,
  SUBMIT_REMOVE_FROM_PSL_ERROR,
  CANCEL_REMOVE_FROM_PSL,
  SHOW_FLASH_MESSAGE,
  HIDE_FLASH_MESSAGE,
} from "./types";
import CurrentUser from "../apiResources/CurrentUser";
import PreferredSupplier from "../apiResources/PreferredSupplier";

export const loadPreferredSuppliersList = () => async (dispatch) => {
  try {
    const currentUser = await CurrentUser.first();

    const suppliersList = await PreferredSupplier.includes([
      { recruiter: "recruiter_users" },
      "employer",
    ]).all();

    dispatch({
      type: LOAD_PSL,
      payload: {
        isEmployer: currentUser.data.isEmployer,
        suppliersList: suppliersList.data,
        isPortalUser: currentUser.data.isPortalUser,
      },
    });
  } catch (error) {
    Sentry.captureException(error);

    dispatch({
      type: LOAD_PSL_ERROR,
    });
  }
};

export const toggleRemoveFromPslModal = () => (dispatch) => {
  dispatch({
    type: TOGGLE_REMOVE_FROM_PSL_MODAL,
  });
};

export const flashMessageHandle = () => (dispatch) => {
  dispatch({ type: SHOW_FLASH_MESSAGE });
  setTimeout(() => dispatch({ type: HIDE_FLASH_MESSAGE }), 2500);
};

export const submitRemovalFromPsl = (data) => async (dispatch) => {
  const { preferredSupplier, message } = data;

  dispatch({
    type: SET_REMOVE_FROM_PSL_LOADING,
  });

  try {
    // You may wonder why we are updating the preferredSupplier
    // immediately before deleting it:
    // See the PreferredSupplier model - we use callbacks
    // to notify of the removal, and the message is required
    // as part of the notification, as such this will
    // fail if we don't write the message to the DB first
    preferredSupplier.message = message;
    await preferredSupplier.save();

    await preferredSupplier.destroy();

    dispatch({
      type: SUBMIT_REMOVE_FROM_PSL,
      payload: preferredSupplier.id,
    });
    dispatch(flashMessageHandle());
  } catch (error) {
    Sentry.captureException(error);

    dispatch({
      type: SUBMIT_REMOVE_FROM_PSL_ERROR,
      payload: error.response.data.errors,
    });
  }
};

export const cancelRemovalFromPsl = () => (dispatch) => {
  dispatch({
    type: CANCEL_REMOVE_FROM_PSL,
  });

  dispatch(toggleRemoveFromPslModal());
};
